import * as React from 'react';
import { capitalize } from 'lodash';

import MediaObject from 'components/MediaObject';
import TextBadge, { Props as TextBadgeProps } from 'components/TextBadge';

type Props = {
  status: 'pending' | 'inactive';
};

export default function AdminSisSyncStatusLabel(props: Props) {
  const { status } = props;

  const statusToColors: {
    [key in Props['status']]: {
      color: TextBadgeProps['color'];
      textColor: TextBadgeProps['textColor'];
    };
  } = {
    pending: {
      color: 'sunrise',
      textColor: 'pitch',
    },
    inactive: {
      color: 'wolf',
      textColor: 'thunder',
    },
  };

  const textSize = 'xxxxsmall';
  const { color, textColor } = statusToColors[status];

  return (
    <MediaObject center figure="right" gutter="xsmall" inline>
      {<span>SIS sync</span>}
      <TextBadge color={color} textColor={textColor} textSize={textSize}>
        {capitalize(status)}
      </TextBadge>
    </MediaObject>
  );
}
